import { useBrand } from 'src/editor/utils/brand/get-brand'
import ExitButton from './ExitButton'
import OpenSettings from './OpenSettings'
import SaveButton from './SaveButton'

const Header = () => {
  const { brand } = useBrand()

  return (
    <div className="bg-text-primary z-10 mx-auto flex h-[69px] w-full items-center justify-between gap-4 px-4 sm:px-6 md:px-14">
      <div className="flex items-center gap-3">
        {brand ? (
          <img
            className="h-[35px] min-h-[35px] w-[35px] min-w-[35px] object-cover"
            src={brand?.logo?.path}
            alt={brand?.name}
          />
        ) : (
          <div className="bg-skeleton-primary h-[35px] w-[35px] animate-pulse rounded-full" />
        )}
        <OpenSettings />
      </div>
      <div className="flex gap-3">
        <SaveButton />
        <ExitButton />
      </div>
    </div>
  )
}

export default Header
